"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogService = void 0;
const http_client_1 = require("@smartsheet/http-client");
const TaskRunner_1 = require("./TaskRunner");
class LogService {
    // private ctor to enforce singleton nature of this class
    constructor() {
        this.MAX_BATCH_SIZE = 100;
        this.PUSH_INTERVAL_MS = 4000;
        this.LOG_SERVICE_PATH = "/2.0/logging-service";
        this.client = http_client_1.genAxiosClient();
        this.logQueue = [];
        this.batches = [];
        this.taskRunner = new TaskRunner_1.TaskRunner(1);
        this.scheduler();
    }
    // Use the instance() method to instantiate the class as a Singleton
    static instance() {
        if (!LogService.INSTANCE) {
            LogService.INSTANCE = new LogService();
        }
        return LogService.INSTANCE;
    }
    // add a LogRequest to the buffer from which we create batches
    push(payload) {
        this.logQueue.push(payload);
    }
    // create and start the scheduled task
    scheduler() {
        setInterval(() => {
            if (this.logQueue.length) {
                this.setBatches();
                this.scheduleTasks();
            }
        }, this.PUSH_INTERVAL_MS);
    }
    // create a batch of LogRequest objects to send to the client and enqueue for worker
    scheduleTasks() {
        if (this.batches.length) {
            while (this.batches.length) {
                const batch = this.batches.shift();
                this.taskRunner.push(() => this.send(batch));
            }
        }
    }
    // extract the next batch of LogRequests from the logQueue
    chunk() {
        return this.logQueue.splice(0, this.MAX_BATCH_SIZE);
    }
    // generate and enqueue batches of LogRequests until the logQueue is empty
    setBatches() {
        while (this.logQueue.length) {
            const batch = this.chunk();
            this.batches.push(batch);
        }
    }
    // send the provided batch via the client to the logging-service
    send(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.post(this.LOG_SERVICE_PATH, payload, http_client_1.genHaloConfig());
        });
    }
}
exports.LogService = LogService;
//# sourceMappingURL=LogService.js.map